import { MIN_PASSWORD_LENGTH, MNOGORU_COUPON_LENGTH } from '@/js/helpers/globalConst';

export default function (field, customMessage = '') {
  let message = '';

  if (field.emailValidator === false || field.email === false || field.checkDomain === false) {
    message = 'Введите корректный Email';
  }

  if (field.firstEmailSymbols === false) {
    message = 'Введите корректный Email';
  }

  if (field.checkCyrr === false || field.notCyrillic === false) {
    message = 'В Email не допускаются русские буквы';
  }

  if (field.checkName === false) {
    message = 'Допускаются только символы A-Z, a-z, А-Я, а-я, -';
  }

  if (field.checkLength === false) {
    message = 'Слишком мало символов';
  }

  if (field.personName === false) {
    message = 'Допускаются только символы A-Z, a-z, А-Я, а-я, -, каждая часть имени должна быть длиннее 1 символа';
  }

  if (field.checkPhone === false || field.phone === false) {
    message = 'Некорректный номер телефона';
  }

  if (field.checkPhoneForRu === false
    || field.phone === false
    || field.checkPhoneForForeign === false
  ) {
    message = 'Некорректный номер телефона';
  }

  if (field.checkCallCenter === false) {
    message = 'Номер телефона запрещен для ввода';
  }

  if (field.phoneMobile === false) {
    message = 'Некорректный номер телефона';
  }

  if (field.fullName === false) {
    message = customMessage !== '' ? customMessage : 'Нужно указать фамилию и имя';
  }

  if (field.required === false) {
    message = customMessage !== '' ? customMessage : 'Поле обязательно для заполнения';
  }

  if (field.numeric === false) {
    message = 'Допускаются только цифры';
  }

  if (field.street === false) {
    message = 'Допускаются только символы A-Z, a-z, А-Я, а-я, 0-9, -';
  }

  if (field.house === false) {
    message = 'Допускаются только цифры или буквы';
  }

  if (field.minDate === false) {
    message = 'Доставка в указанную дату невозможна';
  }

  if (field.maxLength === false) {
    message = customMessage !== '' ? customMessage : 'Значение должно содержать от 10 до 20 символов';
  }

  if (field.minLength === false) {
    message = 'Значение должно содержать от 10 до 20 символов';
  }

  if (field.inn === false) {
    message = 'ИНН должен состоять из 10 или 12 цифр';
  }

  if (field.kpp === false) {
    message = 'Поле должно состоять из 9 цифр, либо 0 если ИП';
  }

  if (field.bik === false) {
    message = 'Поле должно состоять из 9 цифр';
  }

  if (field.account === false) {
    message = 'Поле должно состоять из 20 цифр';
  }

  if (field.fio === false) {
    message = customMessage !== '' ? customMessage : 'ФИО должно состоять из 3 слов, разделенных пробелом';
  }

  if (field.postIndex === false || field.checkIndex === false) {
    message = customMessage !== '' ? customMessage : `
      Доставка Почтой России осуществляется по индексу.
      Укажите индекс, чтобы перейти к следующему шагу.
      Узнать свой индекс можно на сайте:
      <a href="https://www.pochta.ru/post-index" target="_blank">https://www.pochta.ru/post-index</a>
    `;
  }

  if (field.dhlIndex === false) {
    message = 'Экспресс доставка осуществляется по индексу. Укажите индекс, чтобы перейти к следующему шагу.';
  }

  if (field.address === false) {
    message = 'Поле адрес обязательно для заполнения';
  }

  if (field.checkHouse === false) {
    message = customMessage !== '' ? customMessage : 'Необходимо ввести номер дома';
  }

  if (field.street === false) {
    message = 'Необходимо ввести название улицы';
  }

  if (field.phoneMinLength === false) {
    message = 'Телефон должен быть не менее 10 символов';
  }

  if (field.phoneIsValid === false) {
    message = 'Некорректный номер телефона';
  }

  if (field.number === false || field.checkBlock === false || field.checkApartment === false) {
    message = customMessage !== '' ? customMessage : 'Значение должно быть не более 15 символов';
  }

  if (field.organizationNameLength === false) {
    message = 'Название организации должно быть более 100 символов';
  }

  if (field.checkStreet === false) {
    message = customMessage !== '' ? customMessage : 'Необходимо указать название улицы';
  }

  if (field.newPassword === false) {
    message = customMessage !== '' ? customMessage : `Пароль должен содержать не меньше ${MIN_PASSWORD_LENGTH} символов`;
  }

  if (field.confirmPassword === false) {
    message = customMessage !== '' ? customMessage : 'Пароли должны совпадать';
  }

  if (field.mnogoru === false) {
    message = customMessage !== '' ? customMessage : `Купон должен состоять из ${MNOGORU_COUPON_LENGTH} цифр`;
  }

  if (field.checkBirthday === false) {
    message = customMessage !== '' ? customMessage : 'Укажите корректную дату рождения';
  }

  return message;
}
